import React from "react";
import { Car, Dumbbell, Shield, Wifi, MapPin, ArrowRight, BedDouble, Bath } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const featuredFlats = [{
  id: 1,
  title: "Industrial Automation Hub",
  location: "Khu Công Nghiệp, Bắc Ninh",
  price: "Level 4",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/luxury_flat_interior_sonipat.png",
  beds: "Phase 1",
  baths: "Active",
  area: "12,400 m2",
  amenities: [{
    icon: Shield,
    label: "Safety Grade"
  }, {
    icon: Wifi,
    label: "IoT Smart"
  }, {
    icon: Car,
    label: "Logistics"
  }],
  status: "Completed"
}, {
  id: 2,
  title: "Structural Steel Framework",
  location: "Quận 7, TP. Hồ Chí Minh",
  price: "Level 5",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/modern_apartment_rohtak.png",
  beds: "Phase 2",
  baths: "Ready",
  area: "8,500 m2",
  amenities: [{
    icon: Dumbbell,
    label: "High Load"
  }, {
    icon: Shield,
    label: "Fire Proof"
  }, {
    icon: MapPin,
    label: "Urban Site"
  }],
  status: "In Progress"
}, {
  id: 3,
  title: "Renewable Energy Station",
  location: "Huyện Ninh Hải, Ninh Thuận",
  price: "Level 3",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/spacious_flat_bahadurgarh.png",
  beds: "Phase 1",
  baths: "Stable",
  area: "45,000 m2",
  amenities: [{
    icon: Wifi,
    label: "Grid Sync"
  }, {
    icon: Shield,
    label: "Monitoring"
  }, {
    icon: Car,
    label: "Access Rd"
  }],
  status: "Commissioning"
}];
export default function FeaturedFlats() {
  return <section data-section-id="47727" id="related-projects" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-5xl font-default font-extrabold tracking-tighter text-primary mb-4 uppercase">
              Related Engineering Works
            </h2>
            <p className="text-muted-foreground text-lg font-sans">
              Discover our technical expertise through these recently completed industrial and infrastructure solutions, 
              built for maximum efficiency and long-term durability.
            </p>
          </div>
          <Button asChild variant="outline" className="hidden md:inline-flex rounded-none border-l-4 border-cyan-500 bg-primary text-primary-foreground hover:bg-primary/90">
            <Link to="/SolutionsPage">
              View All Solutions <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredFlats.map((flat, i) => <Card key={flat.id} className="group overflow-hidden rounded-none border-none shadow-[0_20px_40px_rgba(0,0,0,0.05)] bg-card transition-all duration-300" data-index={i}>
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={flat.image} alt={flat.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute top-4 left-4">
                  <Badge variant="secondary" className="rounded-none backdrop-blur-md bg-primary/90 text-primary-foreground font-default font-bold uppercase tracking-wider">
                    {flat.status}
                  </Badge>
                </div>
                <div className="absolute bottom-4 right-4">
                  <div className="bg-cyan-500/95 backdrop-blur-sm text-white px-4 py-2 rounded-none font-default font-extrabold text-lg shadow-lg">
                    {flat.price}
                  </div>
                </div>
              </div>

              <CardHeader className="pb-2">
                <div className="flex justify-between items-start gap-4">
                  <div>
                    <CardTitle className="text-2xl mb-2 font-default font-extrabold text-primary transition-colors">
                      {flat.title}
                    </CardTitle>
                    <CardDescription className="flex items-center gap-1.5 font-sans font-medium text-muted-foreground">
                      <MapPin className="h-4 w-4 text-cyan-500" />
                      {flat.location}
                    </CardDescription>
                  </div>
                </div>
              </CardHeader>

              <CardContent className="py-4">
                <div className="flex items-center gap-6 mb-6 text-sm font-sans text-muted-foreground border-b border-border pb-4">
                  <div className="flex items-center gap-2">
                    <BedDouble className="h-4 w-4 text-cyan-500" />
                    <span>{flat.beds}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Bath className="h-4 w-4 text-cyan-500" />
                    <span>{flat.baths}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="h-4 w-4 border border-cyan-500 rounded-none flex items-center justify-center text-[10px] font-bold text-cyan-500">M2</div>
                    <span>{flat.area}</span>
                  </div>
                </div>

                <div className="flex flex-wrap gap-3">
                  {flat.amenities.map((amenity, idx) => <div key={idx} className="flex items-center gap-1.5 text-xs font-default font-bold bg-muted text-primary px-2.5 py-1.5 rounded-none" data-index={idx}>
                      <amenity.icon className="h-3.5 w-3.5 text-cyan-500" />
                      {amenity.label}
                    </div>)}
                </div>
              </CardContent>

              <CardFooter className="pt-2">
                <Button className="w-full rounded-none bg-primary text-primary-foreground border-l-4 border-cyan-500 hover:bg-primary/90 font-default font-bold uppercase tracking-widest" asChild>
                  <Link to="/ProjectsPage">View Details</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>

        <div className="mt-10 text-center md:hidden">
          <Button asChild variant="outline" className="w-full rounded-none border-l-4 border-cyan-500 bg-primary text-primary-foreground">
            <Link to="/SolutionsPage">
              View All Solutions <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}